import {
	IdentityUserAri,
	JiraCoreSiteAri,
	JiraCustomerServiceSiteAri,
	JiraServicedeskSiteAri,
	JiraSoftwareSiteAri,
	PlatformSiteAri,
} from '@atlassian/ari';
import type { EntryPointRef } from '@atlassian/entry-point-types/types';
import { homeAssignedListEntryPoint } from '@atlassian/home-assigned/entrypoint';
import { loadEntryPoint } from 'react-relay';

import { getAggRelayEnvironment } from '@townsquare/relay-utils/agg-environment';
import { createResource } from '@townsquare/router/resources/createResource';
import type { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';
import { expVal } from '@townsquare/stat-sig';
import { fg } from '@townsquare/stat-sig/gate';

type AssignedData = EntryPointRef<typeof homeAssignedListEntryPoint>;

export const assignedResource: RouteResource<AssignedData | undefined> = createResource<
	AssignedData | undefined
>({
	type: 'ASSIGNED',
	// Key is static for now - this may change if we introduce product filters to assigned
	getKey: () => 'assigned-resource',
	getData: async (_routerContext, resourceContext) => {
		const { user, collabContext } = resourceContext as ResourceContext;
		const jiraExists =
			collabContext?.collabContextScoping?.collabContextSiteAris?.some(
				(ari) =>
					JiraCoreSiteAri.check(ari) ||
					JiraCustomerServiceSiteAri.check(ari) ||
					JiraServicedeskSiteAri.check(ari) ||
					JiraSoftwareSiteAri.check(ari),
			) ?? false;

		if (!jiraExists || !expVal('townsquare_assigned_list', 'isEnabled', false)) {
			return;
		}

		const cloudId = collabContext?.rovoWorkspace;

		if (!user?.accountId || !cloudId) {
			return;
		}

		try {
			return loadEntryPoint(
				{ getEnvironment: getAggRelayEnvironment },
				homeAssignedListEntryPoint,
				{
					currentUser: IdentityUserAri.create({ userId: user.accountId }),
					unitId: PlatformSiteAri.create({ siteId: cloudId }),
					enableSmartGrouping: fg('townsquare_enable_assigned_smart_grouping'),
				},
			);
		} catch {
			return;
		}
	},
});
